import {Component, OnInit, ViewChild} from '@angular/core';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {DictionaryService, TableService, UserService, VisitedService} from '@amlCore/services';
import {ActivatedRoute, Router} from '@angular/router';
import {Utils} from '@amlCore/utils';
import {Qref281fzService} from './qref281fz.service';
import {CheckDictEnum, RegistriesAccessEnum} from '@amlCore/enums';
import {AccessJson} from '@amlCore/models';
import {Qref281fzModel} from "../../model/qref281fz.model";
import {IDictItemType} from "@amlCore/interfaces";
import {RegistriesService} from "../../service";
import {AlertPanelComponent} from "@amlCore/components";

@Component({
  selector: 'app-281fz-list',
  templateUrl: './qref281fzList.component.html'
})
export class Qref281fzListComponent extends TableReactiveUrlController implements OnInit {
  params: any;
  isShowVisited = true;
  clientTypes: IDictItemType[];
  qrefList: Qref281fzModel[] = [];
  access: AccessJson;
  loadCheckList = {};
  @ViewChild('alertObjCheck', {static: false}) alertObjToCheck: AlertPanelComponent;

  constructor(protected readonly activatedRoute: ActivatedRoute,
              protected readonly visitedService: VisitedService,
              protected readonly tableService: TableService,
              protected readonly router: Router,
              protected readonly qref281fzService: Qref281fzService,
              private readonly usersService: UserService,
              protected dictSrv: DictionaryService,
              protected readonly regSrv: RegistriesService) {
    super(router, activatedRoute, visitedService, tableService, {sort: 'recordNum', dir: 'ASC'});
  }

  ngOnInit(): void {
    this.access = this.usersService.getAccess(RegistriesAccessEnum.QREF_281FZ);
    this.activatedRoute.queryParams.subscribe((data) => {
      this.loadList(this.syncParams(data));
    });
    this.dictSrv.loadTypeClient().then((result => {
      this.clientTypes = result;
    }));
  }

  loadList(params?: any): void {
    // Удаляем системные переменные
    Utils.removeKeysFromObj(params, '$refresh');
    this.qref281fzService.getList(this.getParams(params)).subscribe(data => {
      this.qrefList = data.content;
      this.total = data.totalElements;
      this.scrollRun();
    });
  }

  onPageChange(params): void {
    this.navigate({...params, ...this.getParams(this.filter)});
    this.resetSelectedAll();
  }

  onSearch(): void {
    const params = this.getSearchPage(this.filter);
    this.onPageChange(params);
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data): any {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  open(data: Qref281fzModel): void {
    if(this.access.readOnly){
      this.toggleView(data.id);
    } else {
      this.tableService.saveScrollPosition(this.commonKeyStore);
      this.router.navigate([`/registries/281fz/${data.id}`]);
      this.saveRowId(data.id);
    }

  }

  /**
   * Столбец "Наименование/ФИО"
   * @param item - строка
   */
  getName(item: Qref281fzModel): string {
    return this.qref281fzService.getName(item);
  }

  getCode2Name(code: string): string {
    return this.dictSrv.getDictByCode(code, this.clientTypes)?.code2;
  }

  /**
   * Проверка по факторам риска
   */
  public checkRiskFactor() {
    this.regSrv.doCheckRiskFactor({id: CheckDictEnum.QREF281FZ}, CheckDictEnum.QREF281FZ, this.loadCheckList, this.alertObjToCheck);
  }

  protected readonly CheckDictEnum = CheckDictEnum;
}
